export default function (date: number): string {
	return (
		new Date(date).toLocaleDateString() +
		' ' +
		new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
	);
}
